type Listener = () => void

const _listeners = new Set<Listener>()
let _lastFiredAt = 0
const DEBOUNCE_MS = 300

function _dispatch() {
  const now = Date.now()
  if (now - _lastFiredAt < DEBOUNCE_MS) return
  _lastFiredAt = now
  _listeners.forEach((fn) => fn())
}

if (typeof window !== 'undefined') {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') _dispatch()
  })
  // pageshow covers bfcache restores on iOS Safari (back-button navigation)
  // where visibilitychange does not fire
  window.addEventListener('pageshow', (e: PageTransitionEvent) => {
    if (e.persisted) _dispatch()
  })
}

export function subscribe(fn: Listener): () => void {
  _listeners.add(fn)
  return () => {
    _listeners.delete(fn)
  }
}

// Exposed for unit tests only — resets internal state
export function _resetForTest() {
  _listeners.clear()
  _lastFiredAt = 0
}

// Exposed for unit tests to trigger dispatch without DOM events
export function _triggerForTest() {
  _dispatch()
}
